import { EXPANDED, SETTINGS_OPEN_QUERY_VALUE } from 'automation-ui-canvas/constants/settings/SettingsParams';
import { OPEN_QUERY_PARAM } from 'automation-ui-canvas/components/flow-header/menu-bar/MenuBar';
export function getSettingsUrl(base, location) {
  const params = getSettingsParams(location, {
    viewSettings: true,
    expanded: location.hash ? location.hash.replace('#', '') : ''
  });
  return `${base}?${params}`;
}
export function getSettingsParams(location, {
  viewSettings,
  expanded
}) {
  const params = new URLSearchParams(location.search);
  if (viewSettings) {
    params.set(OPEN_QUERY_PARAM, SETTINGS_OPEN_QUERY_VALUE);
  } else {
    params.delete(OPEN_QUERY_PARAM);
  }
  if (expanded) {
    params.set(EXPANDED, expanded);
  } else {
    params.delete(EXPANDED);
  }
  return params.toString();
}